module.exports = __webpack_public_path__ + "img/AgentRecharge.f930ca00.png";